export type InvoiceStatus = 'new' | 'paid' | 'failed' | 'refunded' | 'canceled';

export const NEW = 'new';
export const PAID = 'paid';
export const FAILED = 'failed';
export const REFUNDED = 'refunded';
export const CANCELED = 'canceled';
